import { ENTITY_TYPES } from '../constants/knowledge.constants';

/**
 * Check if the data has results
 * @param {*} data
 * @returns
 */
export const hasResults = data =>
  data
    ? Object.values(data).some(category => Object.values(category).some(value => value > 0))
    : false;

/**
 * Filter by tags
 * True - show files
 * False - hide files
 *
 * @param {Boolean} { filters }
 */
export const filterByTags =
  ({ filters }) =>
  ({ tags, labels = [], professional, type }) => {
    try {
      if (filters.SPECIALTY.size > 0 && !filters.SPECIALTY.has(tags.specialty)) {
        return false;
      }

      if (filters.SUBSPECIALTY.size > 0 && !filters.SUBSPECIALTY.has(tags.subspecialty)) {
        return false;
      }

      if (filters.CONTENT_TYPE.size > 0 && !filters.CONTENT_TYPE.has(tags.contentType)) {
        return false;
      }

      if (filters.TARGET_AUDIENCE.size > 0) {
        const targetAudience = tags.targetAudience.some(key => filters.TARGET_AUDIENCE.has(key));

        if (!targetAudience) {
          return false;
        }
      }

      if (filters.LABELS.size > 0) {
        // For contacts, check location in professional.location
        if (type === ENTITY_TYPES.contacts && professional?.location) {
          const locationMatch = professional.location.some(key => filters.LABELS.has(key));
          if (!locationMatch) {
            return false;
          }
        } else {
          // For other content types, check labels
          const label = labels.some(key => filters.LABELS.has(key));
          if (!label) {
            return false;
          }
        }
      }

      return true;
    } catch (e) {
      return false;
    }
  };
